// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2429":"eb5898a278487488","2888":"3c84892d8b0ff84f","4648":"eb5898a278487488"}[chunkId] + ".css";
};